import {
  Component,
  Output,
  EventEmitter,
  Input,
  ChangeDetectionStrategy,
} from "@angular/core";

@Component({
  selector: "app-celo-cancel-save-buttons",
  templateUrl: "./celo-cancel-save-buttons.component.html",
  styleUrls: ["./celo-cancel-save-buttons.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CeloCancelSaveButtonsComponent {
  @Input() showNow: boolean;
  @Output() cancelled = new EventEmitter();
  @Output() save = new EventEmitter();

  @Input() showCancel = true;
  @Input() showSave = true;
  @Input() textSave = "SAVE";
  @Input() textCancel = "CANCEL";
}
